/**
 * Runtime configuration, read from Vite environment variables.
 *
 * The Firebase web config is public by design: it identifies the project, it
 * does not authorise anything. Authorisation is decided by the API from Postgres
 * memberships (Spec §3).
 */

export interface Config {
  readonly firebase: {
    readonly apiKey: string;
    readonly authDomain: string;
    readonly projectId: string;
  };
  readonly apiBaseUrl: string;
  readonly tilesUrl: string;
}

function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(`missing required environment variable ${name}`);
  }
  return value;
}

export function loadConfig(env: ImportMetaEnv = import.meta.env): Config {
  return {
    firebase: {
      apiKey: required('VITE_FIREBASE_API_KEY', env.VITE_FIREBASE_API_KEY),
      authDomain: required('VITE_FIREBASE_AUTH_DOMAIN', env.VITE_FIREBASE_AUTH_DOMAIN),
      projectId: required('VITE_FIREBASE_PROJECT_ID', env.VITE_FIREBASE_PROJECT_ID),
    },
    apiBaseUrl: required('VITE_API_BASE_URL', env.VITE_API_BASE_URL),
    tilesUrl: tilesUrlOf(env),
  };
}

/** Just the tiles URL: a card that only needs to know whether a map archive is
 *  configured reads this instead of `loadConfig()`, which also demands the
 *  Firebase and API variables no map card touches. */
export function tilesUrlOf(env: ImportMetaEnv = import.meta.env): string {
  return env.VITE_TILES_URL ?? '';
}
